// extracted by mini-css-extract-plugin
module.exports = {"truncatedWrapper":"TruncatedText_truncatedWrapper__Vt8yM","truncatedText":"TruncatedText_truncatedText__ipswD"};